import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
export var SidebarSeparator = styled(function (_a) {
    var className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["className", "children"]);
    return (React.createElement("span", __assign({}, htmlAttributes, { className: className, role: "separator", "aria-orientation": "vertical" })));
})(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex-grow: 1;\n    height: 100%;\n  "], ["\n    flex-grow: 1;\n    height: 100%;\n  "]))); });
SidebarSeparator.propTypes = {
    className: PropTypes.string,
};
var templateObject_1;
//# sourceMappingURL=SidebarSeparator.js.map